/**
 * PubNub Configuration
 * 
 * This file contains the PubNub configuration and initialization.
 * Replace the placeholder keys with your actual PubNub keys.
 */

import PubNub from "pubnub";

// PubNub Keys - Replace with your actual keys from PubNub dashboard
// For development, you can use environment variables
export const PUBNUB_PUBLISH_KEY = process.env.REACT_APP_PUBNUB_PUBLISH_KEY || "";
export const PUBNUB_SUBSCRIBE_KEY = process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY || "";

// PubNub Auth Token for Access Manager (PAM v3)
// This token is used when Access Manager is enabled in PubNub dashboard
// export const PUBNUB_AUTH_TOKEN = "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_GCxtBhT-R6Ek6FUEZ0=";
// PubNub instance configuration
export interface PubNubConfig {
  publishKey: string;
  subscribeKey: string;
  userId: string;
  ssl?: boolean;
  logVerbosity?: boolean;
  heartbeatInterval?: number;
  presenceTimeout?: number;
}

/**
 * Creates a PubNub instance with the given user ID
 * @param userId - Unique identifier for the user
 * @returns PubNub instance
 */
export const createPubNubInstance = (userId: string): PubNub => {
  const config: PubNubConfig = {
    publishKey: PUBNUB_PUBLISH_KEY,
    subscribeKey: PUBNUB_SUBSCRIBE_KEY,
    userId: userId,
    ssl: true,
    logVerbosity: import.meta.env.DEV,
    heartbeatInterval: 30,
    presenceTimeout: 60,
  };

  return new PubNub(config);
};

/**
 * Generate a unique channel name for one-to-one chat
 * @param userId1 - First user's ID
 * @param userId2 - Second user's ID
 * @returns Channel name string
 */
export const generateOneToOneChannel = (userId1: string | number, userId2: string | number): string => {
  // Sort IDs to ensure consistent channel name regardless of who initiates
  const sortedIds = [String(userId1), String(userId2)].sort();
  return `chat-1to1-${sortedIds[0]}-${sortedIds[1]}`;
};

/**
 * Generate a unique channel name for a group chat
 * @param groupId - Unique group identifier
 * @returns Channel name string
 */
export const generateGroupChannel = (groupId: string): string => {
  return `chat-group-${groupId}`;
};

/**
 * Channel naming conventions
 */
export const CHANNEL_PREFIXES = {
  ONE_TO_ONE: "chat-1to1-",
  GROUP: "chat-group-",
  PRESENCE: "-pnpres",
  GLOBAL_PRESENCE: "global-presence",
} as const;

export default createPubNubInstance;
